(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/react/components/start-text.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/react/components/start-text.js');

'use strict';

const StartText = () => {
  var _svs$lotto$data$jackp;
  const jackpot = (_svs$lotto$data$jackp = svs.lotto.data.jackpots.find(item => item.winset === 0)) === null || _svs$lotto$data$jackp === void 0 ? void 0 : _svs$lotto$data$jackp.jackpotAmountStringShort;
  return React.createElement("div", {
    className: "start-text"
  }, React.createElement("p", null, "Jackpot Lotto 1 ".concat(jackpot)), React.createElement("p", null, React.createElement("span", null, "Spelstopp onsdagar kl 17:15"), "\xA0och\xA0", React.createElement("span", null, "l\xF6rdagar kl 18:15")));
};
setGlobal('svs.lotto.react.components', {
  StartText
});

 })(window);